import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import SailingScheduleItems from './SailingScheduleItems';

const getTransitTimeRange = (routes) => {
    const transitTimes = routes
        .map(route => {
            const dep = route?.origin?.estimated_date;
            const arr = route?.destination?.estimated_date;
            if (dep && arr) {
                const depDate = new Date(dep);
                const arrDate = new Date(arr);
                const diffDays = Math.ceil((arrDate - depDate) / (1000 * 60 * 60 * 24));
                return diffDays > 0 ? diffDays : null;
            }
            return null;
        })
        .filter(Boolean); // Remove nulls

    if (transitTimes.length === 0) return null;

    const min = Math.min(...transitTimes);
    const max = Math.max(...transitTimes);

    return { min, max };
}

const RouteResultHeader = ({ routes }) => {
    const [expanded, setExpanded] = useState(false);

    const transitTimeRange = getTransitTimeRange(routes);

    return (
        <>
            <div
                className="bg-white p-3 border-bottom d-flex justify-content-between align-items-center"
                style={{ cursor: 'pointer' }}
                onClick={() => setExpanded((prev) => !prev)}
            >
                <div className="d-flex align-items-center">
                    <span className="fw-bold me-3">Week 19</span>
                    <span className="text-secondary">Transit time: {transitTimeRange ? `${transitTimeRange.min} - ${transitTimeRange.max} days` : "-"}</span>
                </div>
                <div className="d-flex align-items-center">
                    <span className="me-3">{routes.length || 0} results</span>
                    {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </div>
            </div>
            {expanded && routes.map((route) => (
                <SailingScheduleItems key={route?.schedule_id} route={route} />
            ))}
        </>
    );
};


const RouteResults = ({ routes }) => {
    return (
        <div className="bg-white rounded-lg shadow-sm">
            <div className="d-flex justify-content-end p-2 border-bottom">
                <div className="text-secondary">
                    SORT BY: <span className="text-primary fw-bold">TRANSIT TIME</span>
                </div>
            </div>

            <RouteResultHeader routes={routes} />

        </div>
    );
};

export default RouteResults;